/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Competence200,
  GetApiV1Competence401,
  GetApiV1Competence500,
  GetApiV1CompetenceQueryParams,
  GetApiV1CompetenceQueryResponse,
} from "../../types/competenceRegistroController/GetApiV1Competence.ts";
import { competenceListItemViewModelPaginatedResponseSchema } from "../competenceListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1CompetenceQueryParamsSchema = z.object({
  filter: z.optional(z.string()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1CompetenceQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Competence200Schema = z.lazy(
  () => competenceListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Competence200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Competence401Schema =
  z.any() as unknown as ToZod<GetApiV1Competence401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Competence500Schema =
  z.any() as unknown as ToZod<GetApiV1Competence500>;

export const getApiV1CompetenceQueryResponseSchema = z.lazy(
  () => getApiV1Competence200Schema,
) as unknown as ToZod<GetApiV1CompetenceQueryResponse>;
